import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Box,
  Hidden,
  Grid,
  Typography,
  useTheme,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  createStyles,
  makeStyles,
  Collapse,
  IconButton,
  Tabs,
  Tab,
  Menu,
  MenuItem,
  InputAdornment,
  Card,
  useMediaQuery,
} from "@material-ui/core";
import {
  Edit,
  Add,
  ExpandMore,
  ExpandLess,
  Search as SearchIcon,
  Close as CloseIcon,
  Menu as MenuIcon,
} from "@material-ui/icons";
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  Cell,
  HeaderCell,
} from "@table-library/react-table-library/table";
import { useRouteMatch } from "react-router-dom";
import Authorities from "../../../../auth/authorities";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import withAuthority from "../../../../components/Auth/withAuthority";
import {
  createModifier,
  createModifierGroup,
  deleteModifier,
  fetchModifier,
  fetchModifierGroupList,
  updateModifierGroup,
} from "../../../../services/menuApp/ModifierGroups";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import { getCookie } from "../../../../utils/cookies";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";
import CardCommon from "../../../../components/card/CardCommon";
import DialogCommon from "../../../../components/dialogs/DialogCommon";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { convertDateFormat } from "../../../../utils/ConvertDateTimeFormat";
import { AxiosError } from "axios";
import ValidationMessage from "../../../../components/validation/ValidationMessage";
import TextfieldDefaultNew from "../../../../components/textField/TextfieldDefaultNew";
import TextfieldCommon from "../../../../components/textField/TextfieldCommon";
import {
  fetchGlobalDepartmentInfo,
  fetchGlobalGroupInfo,
  fetchGlobalProductsInfo,
  fetchProductConfigInfo,
} from "../../../../services/menuApp/printerMenuService";
import { saveLogs } from "../../../../utils/firebase/logs";
import SwitchCommon from "../../../../components/switches/SwitchCommon";
import { CustomTheme } from "../../../../types/customTheme";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import _ from "lodash";
const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    headerStyle: {
      "&:last-of-type": {
        backgroundColor: theme.palette.background.entity_background,
        color: theme.palette.custom.orange.contrastText,
      },
    },
    startHeaderTextStyle: {
      fontWeight: "bold",
      fontSize: "12px",
      display: "flex",
      color: theme.palette.custom.orange.contrastText,
      justifyContent: "start",
      paddingLeft: "16px",
    },
    textStyleHeader: {
      display: "flex",
      justifyContent: "center",
      fontWeight: "bold",
      fontSize: "12px",
      color: theme.palette.custom.orange.contrastText,
    },
    textStyleHeaderEnd: {
      display: "flex",
      justifyContent: "end",
      fontWeight: "bold",
      fontSize: "12px",
      color: theme.palette.custom.orange.contrastText,
      paddingRight: "16px",
    },
    startTextStyle: {
      fontWeight: "bold",
      fontSize: "12px",
      display: "flex",
      color: theme.palette.custom.blue.contrastText,
      justifyContent: "start",
    },
    startNotNodeTextStyle: {
      fontWeight: "bold",
      fontSize: "12px",
      display: "flex",
      color: theme.palette.text.primary,
      justifyContent: "start",
    },
    textStyle: {
      display: "flex",
      justifyContent: "center",
      fontSize: "12px",
    },
    textStyleEnd: {
      display: "flex",
      justifyContent: "end",
      fontSize: "12px",
      paddingRight: "16px",
    },
    selectedRow: {
      cursor: "pointer",
      "&:nth-of-type(n)": {
        color: theme.palette.custom.blue.contrastText,
        backgroundColor: theme.palette.custom.blue.main,
        "&:hover": {
          backgroundColor: theme.palette.custom.blue.light,
        },
      },
    },
    normalRow: {
      cursor: "pointer",
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.background.paper,
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      },
      "&:nth-of-type(even)": {
        backgroundColor: theme.palette.background.entity_background,
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      },
    },
    baseCellRow: {
      placeItems: "center",
      fontSize: "12px",
      height: "40px",
      "&:nth-of-type(1)": {
        left: "0px",
        minWidth: "50%",
        width: "50%",
      },
      "&:nth-of-type(n+2)": {
        minWidth: "25%",
        width: "25%",
      },
    },
    tabsRoot: {
      "& .MuiTabs-root": {
        maxWidth: "calc(100vw - 320px)",
      },
    },
    modalHeaderSticky: {
      position: "sticky",
      top: 0,
      zIndex: 100,
      paddingBottom: "12px",
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    modalHeaderRow1: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        display: "block",
      },
    },
    modalHeaderButtons: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        marginTop: "12px",
        justifyContent: "space-between",
      },
    },
    productCardContainer: {
      maxHeight: "480px",
      overflowY: "auto",
      paddingTop: "12px",
      paddingRight: "8px",
    },
    "@keyframes modifierSkeletonPulse": {
      "0%": { opacity: 1 },
      "50%": { opacity: 0.35 },
      "100%": { opacity: 1 },
    },
    skeletonBar: {
      backgroundColor: theme.palette.action.hover,
      borderRadius: "4px",
      animation: "$modifierSkeletonPulse 1.4s ease-in-out infinite",
    },
  }),
);
function a11yProps(index: any) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}
const ModifierGroups: React.FunctionComponent = () => {
  const [modifierGroupsList, setModifierGroupsList] = useState<any[]>([]);
  const [modifier, setModifier] = useState<any[]>([]);
  const [filteredModifierGroupsList, setFilteredModifierGroupsList] = useState(
    [],
  );
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isProductAddModalOpen, setIsProductAddModalOpen] = useState(false);
  const [isProductEditModalOpen, setIsProductEditModalOpen] = useState(false);
  const [newlyCreatedModifier, setNewlyCreatedModifier] = useState<any>(null);
  const [selectedModifierGroup, setSelectedModifierGroup] = useState<any>("");
  const [mappedModifierGroupData, setMappedModifierGroupData] =
    useState<any>(null);
  const [createErrors, setCreateErrors] = useState<{
    name?: string;
    priceChangePoint?: string;
    min?: string;
    max?: string;
  }>({});
  const [editErrors, setEditErrors] = useState<{
    name?: string;
    priceChangePoint?: string;
    min?: string;
    max?: string;
  }>({});
  const [productsVersion, setProductsVersion] = useState<number>(1);
  const [isLoadingConfig, setIsLoadingConfig] = useState(true);
  const [newModifierGroup, setNewModifierGroup] = useState<Partial<any>>({
    name: "",
    priceChangePoint: 1,
    min: 0,
    max: 10,
    optionType: false,
    groupTemplateRef: "",
    nestedId: "",
  });
  const [editModifierGroup, setEditModifierGroup] = useState<Partial<any>>({
    name: "",
    priceChangePoint: 1,
    min: 0,
    max: 10,
    optionType: false,
    groupTemplateRef: "",
    nestedId: "",
  });
  // Product Selection Modal States
  const [isLoadingProductNode, setIsLoadingProductNode] = useState(false);
  const [isProductNodeLoaded, setIsProductNodeLoaded] = useState(false);
  const [isProductModalLoading, setIsProductModalLoading] = useState(false);
  const [creatingProductId, setCreatingProductId] = useState<any>(null);
  const [deletingProductId, setDeletingProductId] = useState<any>(null);
  const [selectedProductIds, setSelectedProductIds] = useState<any[]>([]);
  const [rawMenuGroups, setRawMenuGroups] = useState<any>({});
  const [rawMenuDepartments, setRawMenuDepartments] = useState<any>({});
  const [rawMenuProducts, setRawMenuProducts] = useState<any>({});
  const [menuNode, setMenuNode] = useState<any>({});
  const [menuNodeInitial, setMenuNodeInitial] = useState<any>({});
  const [activeGroupId, setActiveGroupId] = useState(0);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState("");
  const [filterDepartment, setFilterDepartment] = useState<any>([]);
  const [searchValue, setSearchValue] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const elementsByTitle = useRef<Record<string, any>>({});
  const match: any = useRouteMatch();
  const locationId = match.params.locationId;
  const token = getCookie("idToken");
  const theme: any = useTheme();
  const classes: any = useStyles();
  const isSmall = useMediaQuery(theme.breakpoints.down("xs"));
  const registerElementWithTitle = (title: string, elementRef: any) => {
    if (elementRef) {
      elementsByTitle.current[title] = elementRef;
    }
  };
  const shouldShowModifierGroup = (nestedId: any): boolean => {
    return (
      nestedId === "-99" ||
      nestedId === -99 ||
      nestedId === "" ||
      nestedId === null ||
      nestedId === 0
    );
  };
  const isGroupTemplateRefEditable = (groupTemplateRef: any): boolean => {
    return (
      groupTemplateRef === -99 ||
      groupTemplateRef === "-99" ||
      groupTemplateRef === "" ||
      groupTemplateRef === null
    );
  };
  const findModifierGroupById = (id: number) => {
    return modifierGroupsList.find((group) => group.id === id);
  };
  // Normalises a modifier coming back from the API. The create response returns
  // `modifierGroupId` / `productId` as full objects, the list response returns them
  // as plain ids.
  const normaliseModifier = (item: any) => {
    return {
      ...item,
      modifierGroupId: item.modifierGroupId?.id ?? item.modifierGroupId,
      productId: item.productId?.id ?? item.productId,
    };
  };
  const getModifiersByGroupId = (groupId: any) => {
    return modifier.filter(
      (item: any) => String(item.modifierGroupId) === String(groupId),
    );
  };
  // Used by the delete flow - gives the modifier row (id + version) that belongs
  // to a product inside the selected group.
  const findModifierByProductId = (productId: any) => {
    return modifier.find(
      (item: any) =>
        String(item.modifierGroupId) === String(selectedModifierGroup?.id) &&
        String(item.productId) === String(productId),
    );
  };
  const validateCreateForm = (): boolean => {
    const errors: {
      name?: string;
      priceChangePoint?: string;
      min?: string;
      max?: string;
    } = {};
    if (!newModifierGroup.name?.trim()) {
      errors.name = "Please enter a name";
    }
    const pricePoint = parseInt(newModifierGroup.priceChangePoint);
    if (isNaN(pricePoint) || pricePoint < 0) {
      errors.priceChangePoint = "Price Change Point cannot be less than 0";
    }
    const minVal = parseInt(newModifierGroup.min);
    if (isNaN(minVal) || minVal < 0) {
      errors.min = "Min cannot be less than 0";
    }
    const maxVal = parseInt(newModifierGroup.max);
    if (isNaN(maxVal) || maxVal < 1) {
      errors.max = "Max must be at least 1";
    } else if (minVal > maxVal) {
      errors.max = "Max cannot be less than Min";
    }
    setCreateErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const validateEditForm = (): boolean => {
    const errors: {
      name?: string;
      priceChangePoint?: string;
      min?: string;
      max?: string;
    } = {};
    if (!editModifierGroup.name?.trim()) {
      errors.name = "Please enter a name";
    }
    const pricePoint = parseInt(editModifierGroup.priceChangePoint);
    if (isNaN(pricePoint) || pricePoint < 0) {
      errors.priceChangePoint = "Price Change Point cannot be less than 0";
    }
    const minVal = parseInt(editModifierGroup.min);
    if (isNaN(minVal) || minVal < 0) {
      errors.min = "Min cannot be less than 0";
    }
    const maxVal = parseInt(editModifierGroup.max);
    if (isNaN(maxVal) || maxVal < 1) {
      errors.max = "Max must be at least 1";
    } else if (minVal > maxVal) {
      errors.max = "Max cannot be less than Min";
    }
    setEditErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handlePriceChangePointChange = (
    value: string,
    isEdit: boolean = false,
  ) => {
    if (value === "") {
      if (isEdit) {
        setEditModifierGroup((prev: any) => ({
          ...prev,
          priceChangePoint: "",
        }));
      } else {
        setNewModifierGroup((prev: any) => ({
          ...prev,
          priceChangePoint: "",
        }));
      }
      return;
    }
    const numValue = parseInt(value);
    if (!isNaN(numValue) && numValue >= 0) {
      if (isEdit) {
        setEditModifierGroup((prev: any) => ({
          ...prev,
          priceChangePoint: numValue,
        }));
      } else {
        setNewModifierGroup((prev: any) => ({
          ...prev,
          priceChangePoint: numValue,
        }));
      }
    } else if (!isNaN(numValue) && numValue < 0) {
      if (isEdit) {
        setEditModifierGroup((prev: any) => ({
          ...prev,
          priceChangePoint: 0,
        }));
      } else {
        setNewModifierGroup((prev: any) => ({
          ...prev,
          priceChangePoint: 0,
        }));
      }
    }
  };
  const handleMinChange = (value: string, isEdit: boolean = false) => {
    if (value === "") {
      if (isEdit) {
        setEditModifierGroup((prev: any) => ({
          ...prev,
          min: "",
        }));
      } else {
        setNewModifierGroup((prev: any) => ({
          ...prev,
          min: "",
        }));
      }
      return;
    }
    const numValue = parseInt(value);
    if (!isNaN(numValue) && numValue >= 0) {
      if (isEdit) {
        const currentMax = editModifierGroup.max ?? 10;
        if (numValue > currentMax) {
          setEditModifierGroup((prev: any) => ({
            ...prev,
            min: currentMax,
            max: currentMax,
          }));
        } else {
          setEditModifierGroup((prev: any) => ({
            ...prev,
            min: numValue,
          }));
        }
      } else {
        const currentMax = newModifierGroup.max ?? 10;
        if (numValue > currentMax) {
          setNewModifierGroup((prev: any) => ({
            ...prev,
            min: currentMax,
            max: currentMax,
          }));
        } else {
          setNewModifierGroup((prev: any) => ({
            ...prev,
            min: numValue,
          }));
        }
      }
    }
  };
  const handleMaxChange = (value: string, isEdit: boolean = false) => {
    if (value === "") {
      if (isEdit) {
        setEditModifierGroup((prev: any) => ({
          ...prev,
          max: "",
        }));
      } else {
        setNewModifierGroup((prev: any) => ({
          ...prev,
          max: "",
        }));
      }
      return;
    }
    const numValue = parseInt(value);
    if (!isNaN(numValue) && numValue >= 1) {
      if (isEdit) {
        const currentMin = editModifierGroup.min ?? 0;
        if (numValue < currentMin) {
          setEditModifierGroup((prev: any) => ({
            ...prev,
            min: numValue,
            max: numValue,
          }));
        } else {
          setEditModifierGroup((prev: any) => ({
            ...prev,
            max: numValue,
          }));
        }
      } else {
        const currentMin = newModifierGroup.min ?? 0;
        if (numValue < currentMin) {
          setNewModifierGroup((prev: any) => ({
            ...prev,
            min: numValue,
            max: numValue,
          }));
        } else {
          setNewModifierGroup((prev: any) => ({
            ...prev,
            max: numValue,
          }));
        }
      }
    }
  };
  const validateAndGetPriceChangePoint = (value: any): number => {
    const numValue = parseInt(value);
    if (isNaN(numValue) || numValue < 0) return 0;
    return numValue;
  };
  const validateAndGetMin = (value: any): number => {
    const numValue = parseInt(value);
    if (isNaN(numValue) || numValue < 0) return 0;
    return numValue;
  };
  const validateAndGetMax = (value: any): number => {
    const numValue = parseInt(value);
    if (isNaN(numValue) || numValue < 1) return 10;
    return numValue;
  };
  const getProductConfiguration = useCallback(async () => {
    if (!locationId) return;
    try {
      const { data } = await fetchProductConfigInfo(locationId);
      if (data && data.data) {
        const { productsVersion } = data.data;
        setProductsVersion(productsVersion || 1);
      }
    } catch (error) {
      const err: any = error as AxiosError;
      if (err.response?.status !== 404) {
        console.error("Error fetching product configuration:", error);
      }
    } finally {
      setIsLoadingConfig(false);
    }
  }, [locationId]);
  const getModifier = useCallback(async () => {
    if (!locationId || !token) return;
    setIsLoading(true);
    try {
      const res = await fetchModifier(locationId, token);
      const allModifier = res.data.data || [];
      setModifier(allModifier.map((item: any) => normaliseModifier(item)));
      setError("");
    } catch (error) {
      const err: any = error as AxiosError;
      setError(err?.response?.data?.message || ERROR_MESSAGE_UNEXPECTED_ERROR);
    } finally {
      setIsLoading(false);
    }
  }, [locationId, token]);
  const getModifierGroupList = useCallback(async () => {
    if (!locationId || !token) return;
    setIsLoading(true);
    try {
      const res = await fetchModifierGroupList(locationId, token);
      const allModifierGroups = res.data.data || [];
      const filtered = allModifierGroups.filter((group: any) =>
        shouldShowModifierGroup(group.nestedId),
      );
      setModifierGroupsList(allModifierGroups);
      setFilteredModifierGroupsList(filtered);
      setError("");
    } catch (error) {
      const err: any = error as AxiosError;
      setError(err?.response?.data?.message || ERROR_MESSAGE_UNEXPECTED_ERROR);
    } finally {
      setIsLoading(false);
    }
  }, [locationId, token]);
  const getModifierProductNode = useCallback(async () => {
    if (!locationId) return;
    setIsLoadingProductNode(true);
    try {
      const groupRes = await fetchGlobalGroupInfo(locationId);
      const departmentRes = await fetchGlobalDepartmentInfo(locationId);
      const productRes = await fetchGlobalProductsInfo(locationId);
      const groupsArr = groupRes.data.data || [];
      const deptsArr = departmentRes.data.data || [];
      const prodsArr = productRes.data.data || [];
      const groupsObj = groupsArr.reduce((acc: any, curr: any) => {
        acc[curr.id] = curr;
        return acc;
      }, {});
      const deptsObj = deptsArr.reduce((acc: any, curr: any) => {
        acc[curr.id] = curr;
        return acc;
      }, {});
      const prodsObj = prodsArr.reduce((acc: any, curr: any) => {
        acc[curr.id] = curr;
        return acc;
      }, {});
      setRawMenuGroups(groupsObj);
      setRawMenuDepartments(deptsObj);
      setRawMenuProducts(prodsObj);
      // Nothing to build a menu node from, so the modal has no more data coming.
      if (
        groupsArr.length === 0 ||
        deptsArr.length === 0 ||
        prodsArr.length === 0
      ) {
        setIsProductNodeLoaded(true);
      }
    } catch (error) {
      setIsProductNodeLoaded(true);
      const err: any = error as AxiosError;
      setError(err?.response?.data?.message || ERROR_MESSAGE_UNEXPECTED_ERROR);
    } finally {
      setIsLoadingProductNode(false);
    }
  }, [locationId]);
  useEffect(() => {
    if (
      Object.values(rawMenuProducts).length > 0 &&
      Object.values(rawMenuDepartments).length > 0 &&
      Object.values(rawMenuGroups).length > 0
    ) {
      const convertedMenuData: any = {};
      for (const departmentId in rawMenuDepartments) {
        const department = rawMenuDepartments[departmentId];
        const groupId = department.groupId || department.group_id;
        if (!convertedMenuData[groupId] && rawMenuGroups[groupId]) {
          convertedMenuData[groupId] = {
            ...rawMenuGroups[groupId],
            department: {},
          };
        }
        if (convertedMenuData[groupId]?.department) {
          convertedMenuData[groupId].department[departmentId] = {
            ...department,
            products: {},
          };
        }
      }
      for (const productId in rawMenuProducts) {
        const product = rawMenuProducts[productId];
        const departmentId = product.departmentId || product.department_id;
        const groupId =
          rawMenuDepartments[departmentId]?.groupId ||
          rawMenuDepartments[departmentId]?.group_id;
        if (convertedMenuData[groupId]?.department?.[departmentId]) {
          convertedMenuData[groupId].department[departmentId].products[
            productId
          ] = product;
        }
      }
      for (const key in convertedMenuData) {
        if (convertedMenuData.hasOwnProperty(key)) {
          const department = convertedMenuData[key].department;
          const abc = Object.values(department);
          abc.sort((a: any, b: any) => {
            return (
              parseInt(a.viewOrder || a.view_order || 0) -
              parseInt(b.viewOrder || b.view_order || 0)
            );
          });
          const sortedObj = abc.reduce((acc: any, curr: any) => {
            acc[`a${curr.id}`] = curr;
            return acc;
          }, {});
          convertedMenuData[key].department = sortedObj;
        }
      }
      setMenuNode(convertedMenuData);
      setMenuNodeInitial(convertedMenuData);
      setIsProductNodeLoaded(true);
    }
  }, [rawMenuProducts, rawMenuDepartments, rawMenuGroups]);
  useEffect(() => {
    if (rawMenuDepartments && Object.values(rawMenuDepartments).length > 0) {
      const firstGroup: any = Object.values(rawMenuDepartments)[0];
      setSelectedDepartmentId(firstGroup.id);
    }
  }, [rawMenuDepartments]);
  useEffect(() => {
    if (rawMenuDepartments && Object.values(rawMenuGroups).length > 0) {
      const groupsList: any = Object.values(rawMenuGroups);
      if (groupsList[activeGroupId]) {
        const currentGroup = groupsList[activeGroupId];
        const abc = Object.values(rawMenuDepartments);
        abc.sort((a: any, b: any) => {
          return (
            parseInt(a.viewOrder || a.view_order || 0) -
            parseInt(b.viewOrder || b.view_order || 0)
          );
        });
        const filterMenuDepartment = abc.filter(
          (department: any) =>
            (department.groupId || department.group_id)?.toString() ===
            currentGroup.id?.toString(),
        );
        setFilterDepartment(filterMenuDepartment);
      }
    }
  }, [rawMenuDepartments, rawMenuGroups, activeGroupId]);
  const handleChangeSearch = (e: any) => {
    const val = e.target.value;
    setSearchValue(val);
    if (val) {
      const cloneMenuNode = _.cloneDeep(menuNodeInitial);
      const filteredMenuNodes: any = {};
      for (const id in cloneMenuNode) {
        const group = cloneMenuNode[id];
        const filteredDepartments: any = {};
        for (const depId in group.department) {
          const department = group.department[depId];
          const filteredProducts: any = {};
          for (const prodId in department.products) {
            const product = department.products[prodId];
            if (product.name.toLowerCase().includes(val.toLowerCase())) {
              filteredProducts[prodId] = product;
            }
          }
          if (Object.keys(filteredProducts).length > 0) {
            filteredDepartments[depId] = {
              ...department,
              products: filteredProducts,
            };
          }
        }
        if (Object.keys(filteredDepartments).length > 0) {
          filteredMenuNodes[id] = {
            ...group,
            department: filteredDepartments,
          };
        }
      }
      setMenuNode(filteredMenuNodes);
    } else {
      setMenuNode(menuNodeInitial);
    }
  };
  const handleClearSearch = () => {
    setSearchValue("");
    setMenuNode(menuNodeInitial);
  };
  const handleButtonClick = (title: string) => () => {
    const targetElement = elementsByTitle.current[title];
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  const handleButtonClickMobile = (title: string, deptId: string) => {
    setSelectedDepartmentId(deptId);
    const targetElement = elementsByTitle.current[title];
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  const handleUpdateModifierGroup = async () => {
    if (productsVersion === 1) {
      setError("Modifier groups cannot be edited when product version is 1");
      return;
    }
    if (!editModifierGroup) return;
    if (!validateEditForm()) {
      return;
    }
    setIsSubmitting(true);
    try {
      const updateData: any = {
        id: selectedModifierGroup.id,
        locationId: locationId,
        name: editModifierGroup.name.trim(),
        priceChangePoint: validateAndGetPriceChangePoint(
          editModifierGroup.priceChangePoint,
        ),
        min: validateAndGetMin(editModifierGroup.min),
        max: validateAndGetMax(editModifierGroup.max),
        optionType: editModifierGroup.optionType ? 1 : 0,
        groupTemplateRef: editModifierGroup.groupTemplateRef || "",
        nestedId: editModifierGroup.nestedId || "",
        version: selectedModifierGroup.version,
      };
      await updateModifierGroup(locationId, updateData, token);
      await getModifierGroupList();
      setIsEditModalOpen(false);
      setSelectedModifierGroup("");
      setMappedModifierGroupData(null);
      setEditModifierGroup({
        name: "",
        priceChangePoint: 1,
        min: 0,
        max: 10,
        optionType: false,
        groupTemplateRef: "",
        nestedId: "",
      });
      setEditErrors({});
      setError("");
      saveLogs(
        {
          message: "Modifier Group Updated",
          summary: `Updated modifier group: ${editModifierGroup.name}`,
          type: "info",
          code: "modifier-group-update",
          metadata: { changedBy: "" },
        },
        "menu",
        locationId,
      );
    } catch (error) {
      const err: any = error as AxiosError;
      setError(err?.response?.data?.message || ERROR_MESSAGE_UNEXPECTED_ERROR);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleCreateModifierGroup = async () => {
    if (productsVersion === 1) {
      setError("Modifier groups cannot be created when product version is 1");
      return;
    }
    if (!validateCreateForm()) {
      return;
    }
    setIsSubmitting(true);
    try {
      const createData: any = {
        name: newModifierGroup.name.trim(),
        priceChangePoint: validateAndGetPriceChangePoint(
          newModifierGroup.priceChangePoint,
        ),
        min: validateAndGetMin(newModifierGroup.min),
        max: validateAndGetMax(newModifierGroup.max),
        optionType: newModifierGroup.optionType ? 1 : 0,
        groupTemplateRef: newModifierGroup.groupTemplateRef || "",
        nestedId: "",
        locationId: locationId,
      };
      const response = await createModifierGroup(locationId, createData, token);
      await getModifierGroupList();
      setIsCreateModalOpen(false);
      const createdModifierGroup = response.data.data;
      setNewModifierGroup({
        name: "",
        priceChangePoint: 1,
        min: 0,
        max: 10,
        optionType: false,
        groupTemplateRef: "",
        nestedId: "",
      });
      setCreateErrors({});
      setError("");
      saveLogs(
        {
          message: "Modifier Group Created",
          summary: `Created new modifier group: ${newModifierGroup.name}`,
          type: "info",
          code: "modifier-group-create",
          metadata: { changedBy: "" },
        },
        "menu",
        locationId,
      );
      handleEditClick(createdModifierGroup);
      handleOpenEditModifierModal(createdModifierGroup);
    } catch (error) {
      const err: any = error as AxiosError;
      setError(err?.response?.data?.message || ERROR_MESSAGE_UNEXPECTED_ERROR);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleCreateModifier = async (productId: any) => {
    if (!selectedModifierGroup?.id) return;
    // Highlight the card straight away, without waiting for the response. If the
    // request fails the highlight is rolled back below.
    setSelectedProductIds((prev: any) => [...prev, productId]);
    setCreatingProductId(productId);
    setIsSubmitting(true);
    try {
      const product = rawMenuProducts[productId];
      const createData: any = {
        name: product?.name || "",
        locationId: locationId,
        modifierGroupId: selectedModifierGroup.id,
        productId: productId,
      };
      const response = await createModifier(locationId, createData, token);
      const createdModifier = normaliseModifier(response.data.data);
      setModifier((prev: any) => [...prev, createdModifier]);
      setError("");
      saveLogs(
        {
          message: "Modifier Created",
          summary: `Created new modifier: ${createData.name}`,
          type: "info",
          code: "modifier-create",
          metadata: { changedBy: "" },
        },
        "menu",
        locationId,
      );
    } catch (error) {
      setSelectedProductIds((prev: any) =>
        prev.filter((id: any) => id !== productId),
      );
      const err: any = error as AxiosError;
      setError(err?.response?.data?.message || ERROR_MESSAGE_UNEXPECTED_ERROR);
    } finally {
      setCreatingProductId(null);
      setIsSubmitting(false);
    }
  };
  const handleDeleteModifier = async (productId: any) => {
    const linkedModifier = findModifierByProductId(productId);
    if (!linkedModifier) return;
    // Drop the highlight straight away, without waiting for the response. If the
    // request fails the highlight is put back below.
    setSelectedProductIds((prev: any) =>
      prev.filter((id: any) => id !== productId),
    );
    setDeletingProductId(productId);
    setIsSubmitting(true);
    try {
      await deleteModifier(locationId, linkedModifier.id);
      setModifier((prev: any) =>
        prev.filter((item: any) => item.id !== linkedModifier.id),
      );
      setError("");
      saveLogs(
        {
          message: "Modifier Deleted",
          summary: `Deleted modifier: ${linkedModifier.id}`,
          type: "info",
          code: "modifier-delete",
          metadata: { changedBy: "" },
        },
        "menu",
        locationId,
      );
    } catch (error) {
      setSelectedProductIds((prev: any) => [...prev, productId]);
      const err: any = error as AxiosError;
      setError(err?.response?.data?.message || ERROR_MESSAGE_UNEXPECTED_ERROR);
    } finally {
      setDeletingProductId(null);
      setIsSubmitting(false);
    }
  };
  const handleToggleProduct = (productId: any) => {
    // A request is already in flight for this card, ignore the click.
    if (creatingProductId === productId || deletingProductId === productId) {
      return;
    }
    if (selectedProductIds.includes(productId)) {
      handleDeleteModifier(productId);
      return;
    }
    handleCreateModifier(productId);
  };
  const handleOpenEditModifierModal = (
    modifierGroup: any = selectedModifierGroup,
  ) => {
    const groupModifiers = getModifiersByGroupId(modifierGroup?.id);
    setSelectedProductIds(groupModifiers.map((item: any) => item.productId));
    setSearchValue("");
    setMenuNode(menuNodeInitial);
    setActiveGroupId(0);
    // The product grid is heavy to render, so the modal is painted with a loader
    // first and the cards are rendered only after that frame has been painted.
    setIsProductModalLoading(true);
    setIsProductEditModalOpen(true);
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        setIsProductModalLoading(false);
      });
    });
  };
  const handleCloseProductModal = () => {
    setIsProductEditModalOpen(false);
    setSelectedProductIds([]);
  };
  const handleAddProduct = () => {
    console.log("Add product for modifier:", newlyCreatedModifier);
    setIsProductAddModalOpen(false);
    setNewlyCreatedModifier(null);
  };
  const handleEditClick = (modifierGroup: any) => {
    if (productsVersion === 1) {
      setError("Modifier groups cannot be edited when product version is 1");
      return;
    }
    setSelectedModifierGroup(modifierGroup);
    if (!isGroupTemplateRefEditable(modifierGroup.groupTemplateRef)) {
      const mappedData = findModifierGroupById(modifierGroup.groupTemplateRef);
      if (mappedData) {
        setMappedModifierGroupData(mappedData);
        setEditModifierGroup({
          name: mappedData.name || "",
          priceChangePoint: mappedData.priceChangePoint ?? 1,
          min: mappedData.min ?? 0,
          max: mappedData.max ?? 10,
          optionType: mappedData.optionType === 1,
          groupTemplateRef: mappedData.groupTemplateRef || "",
          nestedId: mappedData.nestedId || "",
        });
      } else {
        setMappedModifierGroupData(null);
        setEditModifierGroup({
          name: "No matching modifier group found",
          priceChangePoint: 1,
          min: 0,
          max: 10,
          optionType: false,
          groupTemplateRef: modifierGroup.groupTemplateRef || "",
          nestedId: "",
        });
      }
    } else {
      setMappedModifierGroupData(null);
      setEditModifierGroup({
        name: modifierGroup.name || "",
        priceChangePoint: modifierGroup.priceChangePoint ?? 1,
        min: modifierGroup.min ?? 0,
        max: modifierGroup.max ?? 10,
        optionType: modifierGroup.optionType === 1,
        groupTemplateRef: modifierGroup.groupTemplateRef || "",
        nestedId: modifierGroup.nestedId || "",
      });
    }
    setIsEditModalOpen(true);
  };
  useEffect(() => {
    document.title = "Menu - Modifier Groups";
    getProductConfiguration();
    getModifierGroupList();
    getModifier();
    getModifierProductNode();
  }, [
    getProductConfiguration,
    getModifierGroupList,
    getModifier,
    getModifierProductNode,
  ]);
  const isActionsDisabled = productsVersion === 1 || isLoadingConfig;
  const isEditModalDisabled = !isGroupTemplateRefEditable(
    selectedModifierGroup?.groupTemplateRef,
  );
  const hasMappedData = mappedModifierGroupData !== null;
  const getOptionTypeText = (optionType: number) => {
    return optionType === 1 ? "Active" : "Inactive";
  };
  const ModifierGroupCard = ({ modifierGroup }: { modifierGroup: any }) => {
    return (
      <CardCommon backgroundColor="entity_background">
        <Grid container style={{ minHeight: "40px", placeItems: "center" }}>
          <Grid item xs={2} style={{ paddingLeft: "12px" }}>
            <Typography align="left">{modifierGroup.name || "-"}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography align="left">
              {modifierGroup.priceChangePoint ?? "-"}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography align="left">
              {modifierGroup.min ?? "-"} / {modifierGroup.max ?? "-"}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography align="left">
              {getOptionTypeText(modifierGroup.optionType)}
            </Typography>
          </Grid>
          <Grid item xs={2} style={{ paddingRight: "12px" }}>
            <Typography align="left">
              {modifierGroup.created
                ? convertDateFormat(modifierGroup.created)
                : "-"}
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: "12px",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <ButtonCommon
              style={{
                fontSize: 11,
                minWidth: "28px",
                height: "28px",
              }}
              variant="contained"
              color="yellow"
              onClick={() => handleEditClick(modifierGroup)}
              isDisabled={isSubmitting || isActionsDisabled}
              title={
                isActionsDisabled
                  ? "Editing disabled when product version is 1"
                  : ""
              }
            >
              <Edit style={{ fontSize: "16px" }} />
            </ButtonCommon>
          </Grid>
        </Grid>
      </CardCommon>
    );
  };
  const HeaderCard = () => (
    <CardCommon backgroundColor="table_header_background">
      <Grid container style={{ minHeight: "40px", placeItems: "center" }}>
        <Grid item xs={2} style={{ paddingLeft: "12px" }}>
          <Typography
            variant="body2"
            align="left"
            style={{ fontWeight: "bold" }}
          >
            Name
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography
            align="left"
            variant="body2"
            style={{ fontWeight: "bold" }}
          >
            Price Change Point
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography
            align="left"
            variant="body2"
            style={{ fontWeight: "bold" }}
          >
            Min/Max
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography
            align="left"
            variant="body2"
            style={{ fontWeight: "bold" }}
          >
            Option Type
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography
            align="left"
            variant="body2"
            style={{ fontWeight: "bold" }}
          >
            Created
          </Typography>
        </Grid>
        <Grid item xs={2} style={{ paddingRight: "12px", textAlign: "right" }}>
          <Typography
            align="right"
            variant="body2"
            style={{ fontWeight: "bold" }}
          >
            Actions
          </Typography>
        </Grid>
      </Grid>
    </CardCommon>
  );
  if (isLoadingConfig) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box p={3}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Box>
            <Typography variant="h5" style={{ fontWeight: "bold" }}>
              Modifier Groups
            </Typography>
          </Box>
          <ButtonCommon
            color="yellow"
            onClick={() => setIsCreateModalOpen(true)}
            isLoadingPage={isSubmitting}
            style={{ width: "280px" }}
            isDisabled={isActionsDisabled}
            title={
              isActionsDisabled
                ? "Creating disabled when product version is 1"
                : ""
            }
          >
            <Add style={{ marginRight: "4px" }} />
            Create New Modifier Group
          </ButtonCommon>
        </Box>
        {isLoading ? (
          <Box display="flex" justifyContent="center" p={5}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <HeaderCard />
            {filteredModifierGroupsList.length === 0 && (
              <CardCommon backgroundColor="entity_background">
                <Box p={4} textAlign="center">
                  <Typography>
                    {isActionsDisabled
                      ? "No modifier groups found. Creating new modifier groups is disabled when product version is 1."
                      : "No modifier groups found"}
                  </Typography>
                </Box>
              </CardCommon>
            )}
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                marginTop: "8px",
              }}
            >
              {filteredModifierGroupsList.map((modifierGroup: any) => (
                <ModifierGroupCard
                  key={modifierGroup.id}
                  modifierGroup={modifierGroup}
                />
              ))}
            </Box>
          </>
        )}
      </Box>
      {/* Create Modifier Group Modal */}
      <DialogCommon open={isCreateModalOpen} setOpen={setIsCreateModalOpen}>
        <Box p={4} style={{ minWidth: 500, maxWidth: 600 }}>
          <Typography variant="h6" style={{ marginTop: 0, marginBottom: 16 }}>
            Create New Modifier Group
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={8}>
                  <TextfieldDefaultNew
                    id="name"
                    name="name"
                    label="Name"
                    type="text"
                    value={newModifierGroup.name}
                    onChange={(e: any) =>
                      setNewModifierGroup((prev: any) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                    margin="normal"
                    error={!!createErrors.name}
                  />
                  {createErrors.name && (
                    <ValidationMessage message={createErrors.name} />
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    <FormControlLabel
                      style={{ marginRight: "0px" }}
                      checked={newModifierGroup.optionType}
                      onChange={(e: any) =>
                        setNewModifierGroup((prev: any) => ({
                          ...prev,
                          optionType: e.target.checked,
                        }))
                      }
                      control={<SwitchCommon />}
                      label="Option Type"
                      labelPlacement="start"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <TextfieldDefaultNew
                id="priceChangePoint"
                name="priceChangePoint"
                label="Price Change Point"
                type="number"
                value={newModifierGroup.priceChangePoint}
                onChange={(e: any) =>
                  handlePriceChangePointChange(e.target.value, false)
                }
                margin="normal"
                error={!!createErrors.priceChangePoint}
              />
              {createErrors.priceChangePoint && (
                <ValidationMessage message={createErrors.priceChangePoint} />
              )}
            </Grid>
            <Grid item xs={4}>
              <TextfieldDefaultNew
                id="min"
                name="min"
                label="Min"
                type="number"
                value={newModifierGroup.min}
                onChange={(e: any) => handleMinChange(e.target.value, false)}
                margin="normal"
                error={!!createErrors.min}
              />
              {createErrors.min && (
                <ValidationMessage message={createErrors.min} />
              )}
            </Grid>
            <Grid item xs={4}>
              <TextfieldDefaultNew
                id="max"
                name="max"
                label="Max"
                type="number"
                value={newModifierGroup.max}
                onChange={(e: any) => handleMaxChange(e.target.value, false)}
                margin="normal"
                error={!!createErrors.max}
              />
              {createErrors.max && (
                <ValidationMessage message={createErrors.max} />
              )}
            </Grid>
            <Grid item xs={12}>
              <TextfieldDefaultNew
                id="groupTemplateRef"
                name="groupTemplateRef"
                label="Group Template Ref"
                type="number"
                value={newModifierGroup.groupTemplateRef || ""}
                onChange={(e: any) =>
                  setNewModifierGroup((prev: any) => ({
                    ...prev,
                    groupTemplateRef: e.target.value
                      ? parseInt(e.target.value)
                      : "",
                  }))
                }
                margin="normal"
              />
            </Grid>
          </Grid>
          <Box
            display="flex"
            justifyContent="flex-end"
            style={{ gap: "2px" }}
            mt={3}
          >
            <ButtonCommon
              onClick={() => {
                setIsCreateModalOpen(false);
                setCreateErrors({});
                setNewModifierGroup({
                  name: "",
                  priceChangePoint: 1,
                  min: 0,
                  max: 10,
                  optionType: false,
                  groupTemplateRef: "",
                  nestedId: "",
                });
              }}
              color="yellow"
              isDisabled={isSubmitting}
              style={{ width: "100px", marginRight: "12px" }}
            >
              Cancel
            </ButtonCommon>
            <ButtonCommon
              onClick={handleCreateModifierGroup}
              color="yellow"
              isLoadingPage={isSubmitting}
              style={{ width: "100px" }}
              isDisabled={productsVersion === 1}
            >
              Create
            </ButtonCommon>
          </Box>
        </Box>
      </DialogCommon>
      {/* Product Add Modal - Shows after create */}
      <DialogCommon
        open={isProductAddModalOpen}
        setOpen={setIsProductAddModalOpen}
      >
        <Box p={4} style={{ minWidth: 500, maxWidth: 600 }}>
          <Typography variant="h6" style={{ marginTop: 0, marginBottom: 16 }}>
            Add Product to Modifier Group
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginBottom: 16 }}
          >
            Modifier Group "{newlyCreatedModifier?.name}" created successfully.
            You can now add products to this modifier group.
          </Typography>
          <Box p={3} textAlign="center">
            <Typography color="textSecondary">
              Product selection form will be added here
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="flex-end"
            style={{ gap: "2px" }}
            mt={3}
          >
            <ButtonCommon
              onClick={() => {
                setIsProductAddModalOpen(false);
                setNewlyCreatedModifier(null);
              }}
              color="yellow"
              style={{ width: "100px", marginRight: "12px" }}
            >
              Cancel
            </ButtonCommon>
            <ButtonCommon
              onClick={handleAddProduct}
              color="yellow"
              style={{ width: "100px" }}
            >
              Add Product
            </ButtonCommon>
          </Box>
        </Box>
      </DialogCommon>
      {/* Edit Modifier Group Modal */}
      <DialogCommon open={isEditModalOpen} setOpen={setIsEditModalOpen}>
        <Box p={4} style={{ minWidth: 500, maxWidth: 600 }}>
          <Typography variant="h6" style={{ marginTop: 0, marginBottom: 16 }}>
            Edit Modifier Group
            {selectedModifierGroup?.groupTemplateRef &&
              !isGroupTemplateRefEditable(
                selectedModifierGroup.groupTemplateRef,
              ) && (
                <Typography
                  variant="caption"
                  display="block"
                  color="textSecondary"
                >
                  {hasMappedData
                    ? `Showing data from linked modifier group ID: ${selectedModifierGroup.groupTemplateRef}`
                    : `No matching modifier group found for ID: ${selectedModifierGroup.groupTemplateRef}`}
                </Typography>
              )}
          </Typography>
          {hasMappedData ||
          isGroupTemplateRefEditable(
            selectedModifierGroup?.groupTemplateRef,
          ) ? (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={8}>
                    <TextfieldDefaultNew
                      id="edit-name"
                      name="edit-name"
                      label="Name"
                      type="text"
                      value={editModifierGroup.name}
                      onChange={(e: any) =>
                        setEditModifierGroup((prev: any) => ({
                          ...prev,
                          name: e.target.value,
                        }))
                      }
                      margin="normal"
                      disabled={isEditModalDisabled}
                      error={!!editErrors.name}
                    />
                    {editErrors.name && (
                      <ValidationMessage message={editErrors.name} />
                    )}
                  </Grid>
                  <Grid item xs={4}>
                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      alignItems="center"
                    >
                      <FormControlLabel
                        style={{ marginRight: "0px" }}
                        checked={editModifierGroup.optionType}
                        onChange={(e: any) =>
                          setEditModifierGroup((prev: any) => ({
                            ...prev,
                            optionType: e.target.checked,
                          }))
                        }
                        disabled={isEditModalDisabled}
                        control={<SwitchCommon />}
                        label="Option Type"
                        labelPlacement="start"
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <TextfieldDefaultNew
                  id="edit-priceChangePoint"
                  name="edit-priceChangePoint"
                  label="Price Change Point"
                  type="number"
                  value={editModifierGroup.priceChangePoint}
                  onChange={(e: any) =>
                    handlePriceChangePointChange(e.target.value, true)
                  }
                  margin="normal"
                  disabled={isEditModalDisabled}
                  error={!!editErrors.priceChangePoint}
                />
                {editErrors.priceChangePoint && (
                  <ValidationMessage message={editErrors.priceChangePoint} />
                )}
              </Grid>
              <Grid item xs={4}>
                <TextfieldDefaultNew
                  id="edit-min"
                  name="edit-min"
                  label="Min"
                  type="number"
                  value={editModifierGroup.min}
                  onChange={(e: any) => handleMinChange(e.target.value, true)}
                  margin="normal"
                  disabled={isEditModalDisabled}
                  error={!!editErrors.min}
                />
                {editErrors.min && (
                  <ValidationMessage message={editErrors.min} />
                )}
              </Grid>
              <Grid item xs={4}>
                <TextfieldDefaultNew
                  id="edit-max"
                  name="edit-max"
                  label="Max"
                  type="number"
                  value={editModifierGroup.max}
                  onChange={(e: any) => handleMaxChange(e.target.value, true)}
                  margin="normal"
                  disabled={isEditModalDisabled}
                  error={!!editErrors.max}
                />
                {editErrors.max && (
                  <ValidationMessage message={editErrors.max} />
                )}
              </Grid>
              <Grid item xs={12}>
                <TextfieldDefaultNew
                  id="edit-groupTemplateRef"
                  name="edit-groupTemplateRef"
                  label="Group Template Ref"
                  type="number"
                  value={editModifierGroup.groupTemplateRef || ""}
                  onChange={(e: any) =>
                    setEditModifierGroup((prev: any) => ({
                      ...prev,
                      groupTemplateRef: e.target.value
                        ? parseInt(e.target.value)
                        : "",
                    }))
                  }
                  margin="normal"
                  disabled={
                    !isGroupTemplateRefEditable(
                      selectedModifierGroup?.groupTemplateRef,
                    )
                  }
                />
              </Grid>
            </Grid>
          ) : (
            <Box p={3} textAlign="center">
              <Typography color="error">
                No matching modifier group found for ID:{" "}
                {selectedModifierGroup?.groupTemplateRef}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ marginTop: 8 }}
              >
                Please check the Group Template Reference ID or contact support.
              </Typography>
            </Box>
          )}
          <Box
            display="flex"
            justifyContent="flex-end"
            style={{ gap: "2px" }}
            mt={3}
          >
            <ButtonCommon
              onClick={() => {
                setIsEditModalOpen(false);
                setSelectedModifierGroup("");
                setMappedModifierGroupData(null);
                setEditErrors({});
                setEditModifierGroup({
                  name: "",
                  priceChangePoint: 1,
                  min: 0,
                  max: 10,
                  optionType: false,
                  groupTemplateRef: "",
                  nestedId: "",
                });
              }}
              color="yellow"
              isDisabled={isSubmitting}
              style={{ width: "100px", marginRight: "12px" }}
            >
              Cancel
            </ButtonCommon>
            {(hasMappedData ||
              isGroupTemplateRefEditable(
                selectedModifierGroup?.groupTemplateRef,
              )) && (
              <>
                <ButtonCommon
                  onClick={handleUpdateModifierGroup}
                  color="yellow"
                  isLoadingPage={isSubmitting}
                  style={{ width: "100px", marginRight: "12px" }}
                  isDisabled={productsVersion === 1 || isEditModalDisabled}
                >
                  Save
                </ButtonCommon>
                <ButtonCommon
                  onClick={() => handleOpenEditModifierModal()}
                  color="yellow"
                  style={{ width: "160px" }}
                  isDisabled={isEditModalDisabled}
                >
                  Edit Modifier
                </ButtonCommon>
              </>
            )}
          </Box>
        </Box>
      </DialogCommon>
      {/* Product Selection Modal */}
      <DialogCommonDefault
        open={isProductEditModalOpen}
        setOpen={setIsProductEditModalOpen}
        maxWidth="lg"
        isNeedFixedHeight={false}
      >
        <Box p={3} style={{ width: "100%" }}>
          {/* Fixed/Sticky Top Header Area */}
          <div className={classes.modalHeaderSticky}>
            <Box mb={1}>
              <Typography variant="h5" style={{ fontWeight: "bold" }}>
                LINK PRODUCTS TO MODIFIER GROUP
                {selectedModifierGroup?.name
                  ? ` - ${selectedModifierGroup.name}`
                  : ""}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ marginTop: "4px" }}
              >
                Select a product to add it as a modifier of this modifier group.
              </Typography>
            </Box>
            <div className={classes.modalHeaderRow1}>
              <Tabs
                classes={{ root: classes.tabsRoot }}
                value={activeGroupId}
                onChange={(e: any, val: any) => setActiveGroupId(val)}
                variant="scrollable"
                scrollButtons="auto"
                indicatorColor="secondary"
                textColor="secondary"
              >
                {!_.isEmpty(rawMenuGroups) &&
                  Object.values(rawMenuGroups).map(
                    (group: any, idx: number) => (
                      <Tab
                        key={String(idx)}
                        onClick={handleButtonClick(`group ${group.id}`)}
                        label={
                          <Typography style={{ fontSize: "14px" }}>
                            {group.name}
                          </Typography>
                        }
                        {...a11yProps(group)}
                      />
                    ),
                  )}
              </Tabs>
              <div className={classes.modalHeaderButtons}>
                <ButtonCommon
                  onClick={handleCloseProductModal}
                  variant="contained"
                  color="yellow"
                  style={{
                    fontSize: 11,
                    width: "110px",
                    marginRight: "10px",
                  }}
                >
                  Cancel
                </ButtonCommon>
              </div>
            </div>
            {/* Department Menu Filter & Search Row */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mt={1.5}
            >
              <Box display="flex" alignItems="center">
                <IconButton
                  size="small"
                  style={{
                    marginRight: "12px",
                    backgroundColor: theme.palette.background.entity_background,
                    borderRadius: "8px",
                    padding: "6px",
                  }}
                  onClick={(e: any) => setAnchorEl(e.currentTarget)}
                >
                  {Boolean(anchorEl) ? <CloseIcon /> : <MenuIcon />}
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}
                  PaperProps={{
                    elevation: 1,
                    style: {
                      borderRadius: "8px",
                      border: `1px solid ${theme.palette.divider}`,
                      marginTop: "40px",
                    },
                  }}
                >
                  {!_.isEmpty(filterDepartment) &&
                    filterDepartment.map((dept: any) => (
                      <MenuItem
                        key={dept.id}
                        onClick={() => {
                          handleButtonClickMobile(
                            `department ${dept.id}`,
                            dept.id,
                          );
                          setAnchorEl(null);
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: "13px",
                            fontWeight:
                              selectedDepartmentId === dept.id
                                ? "bold"
                                : "normal",
                          }}
                        >
                          {dept.name}
                        </Typography>
                      </MenuItem>
                    ))}
                </Menu>
                <TextfieldDefaultNew
                  id="search"
                  name="search"
                  label="Search"
                  type="text"
                  style={{ width: isSmall ? "180px" : "240px" }}
                  value={searchValue}
                  onChange={handleChangeSearch}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {searchValue ? (
                          <CloseIcon
                            style={{ cursor: "pointer", fontSize: "18px" }}
                            onClick={handleClearSearch}
                          />
                        ) : (
                          <SearchIcon style={{ fontSize: "18px" }} />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              {/* <Typography variant="body2" color="textSecondary">
                Selected: <strong>{selectedProductIds.length}</strong>
              </Typography> */}
            </Box>
          </div>
          {/* Cards Body Section */}
          {!isProductNodeLoaded ||
          isLoadingProductNode ||
          isProductModalLoading ? (
            <Box display="flex" justifyContent="center" p={5}>
              <CircularProgress />
            </Box>
          ) : (
            <div className={classes.productCardContainer}>
              {!_.isEmpty(menuNode) ? (
                Object.values(menuNode).map(
                  (group: any, index: any) =>
                    ((group.id >= 0 && activeGroupId === index) ||
                      searchValue) && (
                      <div
                        key={group.id}
                        ref={(ref) =>
                          registerElementWithTitle(`group ${group.id}`, ref)
                        }
                      >
                        {!_.isEmpty(group.department) &&
                          Object.values(group.department).map(
                            (department: any) =>
                              department.name !== "Online Hidden" &&
                              department.name !== "Templates" && (
                                <div
                                  key={department.id}
                                  ref={(ref) =>
                                    registerElementWithTitle(
                                      `department ${department.id}`,
                                      ref,
                                    )
                                  }
                                  style={{ marginBottom: "24px" }}
                                >
                                  {/* Department Title Header */}
                                  <Card
                                    style={{
                                      backgroundColor:
                                        theme.palette.background.paper,
                                      borderRadius: "8px",
                                      border: `1px solid ${theme.palette.background.entity_highlight_background}`,
                                      padding: "8px 14px",
                                      marginBottom: "12px",
                                      boxShadow: "none",
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      color="textSecondary"
                                    >
                                      {group.name}
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      style={{
                                        fontWeight: "bold",
                                        lineHeight: 1.2,
                                      }}
                                    >
                                      {department.name}
                                    </Typography>
                                  </Card>
                                  {/* Products Grid Under Current Department */}
                                  <Grid container spacing={2}>
                                    {!_.isEmpty(department.products) &&
                                      Object.values(department.products).map(
                                        (prod: any) => {
                                          const isSelected =
                                            selectedProductIds.includes(
                                              prod.id,
                                            );
                                          return (
                                            <Grid
                                              item
                                              xs={12}
                                              sm={6}
                                              md={4}
                                              lg={3}
                                              key={prod.id}
                                            >
                                              <Card
                                                style={{
                                                  backgroundColor: isSelected
                                                    ? theme.palette.custom?.blue
                                                        ?.main || "#2196f3"
                                                    : theme.palette.background
                                                        .entity_background,
                                                  borderRadius: "8px",
                                                  border: `1px solid ${
                                                    isSelected
                                                      ? theme.palette.custom
                                                          ?.blue?.light ||
                                                        "#64b5f6"
                                                      : theme.palette.background
                                                          .entity_background
                                                  }`,
                                                  cursor: "pointer",
                                                  padding: "10px 12px",
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  justifyContent:
                                                    "space-between",
                                                  minHeight: "72px",
                                                  boxShadow: "none",
                                                }}
                                                onClick={() =>
                                                  handleToggleProduct(prod.id)
                                                }
                                              >
                                                {creatingProductId ===
                                                  prod.id ||
                                                deletingProductId ===
                                                  prod.id ? (
                                                  <>
                                                    <div
                                                      className={
                                                        classes.skeletonBar
                                                      }
                                                      style={{
                                                        height: "13px",
                                                        width: "80%",
                                                      }}
                                                    />
                                                    <Box
                                                      display="flex"
                                                      justifyContent="space-between"
                                                      alignItems="center"
                                                      mt={1}
                                                    >
                                                      <div
                                                        className={
                                                          classes.skeletonBar
                                                        }
                                                        style={{
                                                          height: "10px",
                                                          width: "40%",
                                                        }}
                                                      />
                                                      <div
                                                        className={
                                                          classes.skeletonBar
                                                        }
                                                        style={{
                                                          height: "10px",
                                                          width: "25%",
                                                        }}
                                                      />
                                                    </Box>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Typography
                                                      align="left"
                                                      style={{
                                                        fontSize: "13px",
                                                        fontWeight: 600,
                                                        color: isSelected
                                                          ? "#fff"
                                                          : theme.palette.text
                                                              .primary,
                                                        lineHeight: 1.3,
                                                      }}
                                                    >
                                                      {prod.name}
                                                    </Typography>
                                                    <Box
                                                      display="flex"
                                                      justifyContent="space-between"
                                                      alignItems="center"
                                                      mt={1}
                                                    >
                                                      <Typography
                                                        variant="caption"
                                                        style={{
                                                          color: isSelected
                                                            ? "rgba(255, 255, 255, 0.8)"
                                                            : theme.palette.text
                                                                .secondary,
                                                        }}
                                                      >
                                                        PLU: {prod.plu || "N/A"}
                                                      </Typography>
                                                      <Typography
                                                        variant="caption"
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: isSelected
                                                            ? "#fff"
                                                            : theme.palette.text
                                                                .primary,
                                                        }}
                                                      >
                                                        {parseFloat(
                                                          prod.price || 0,
                                                        ).toFixed(2)}
                                                      </Typography>
                                                    </Box>
                                                  </>
                                                )}
                                              </Card>
                                            </Grid>
                                          );
                                        },
                                      )}
                                  </Grid>
                                </div>
                              ),
                          )}
                      </div>
                    ),
                )
              ) : (
                <Box p={4} textAlign="center">
                  <Typography color="textSecondary">
                    No products found
                  </Typography>
                </Box>
              )}
            </div>
          )}
        </Box>
      </DialogCommonDefault>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};
export default withAuthority(ModifierGroups, Authorities.MENU_READ);